export const teamMatesMock = [
  {
    picture: '/public/img/26115.jpg',
    firstname: 'Damon',
    lastname: 'Parker',
    profile: 'Admin',
    profileColor: 'danger'
  },
  {
    picture: '/public/img/26115.jpg',
    firstname: 'Joe',
    lastname: 'Waston',
    profile: 'Member',
    profileColor: 'warning'
  },
  {
    picture: '/public/img/26115.jpg',
    firstname: 'Jannie',
    lastname: 'Davis',
    profile: 'Editor',
    profileColor: 'warning'
  },
  {
    picture: '/public/img/26115.jpg',
    firstname: 'Emma',
    lastname: 'Welson',
    profile: 'Editor',
    profileColor: 'success'
  },
  {
    picture: '/public/img/26115.jpg',
    firstname: 'Emma',
    lastname: 'Welson',
    profile: 'Editor',
    profileColor: 'info'
  }
];



// WEBPACK FOOTER //
// ./src/app/models/teamMatesMock.js